<template>
  <div @click="handler" class="d-flex justify-content-center flex-column">
    <div class="circle">
      <img class="plus-icon" :src="require(`@/assets/icons/${icon}.svg`)">
    </div>
    <span class="textCircle">{{text}}</span>
  </div>
</template>

<script>
export default {
  name: 'ButtonPlus',
  props: {
    text: {
      type: String,
      default: () => 'Filtro'
    },
    icon: {
      type: String,
      default: () => 'plus'
    },
    groupIndex: {
      type: Number,
      default: () => null
    },
  },
  methods: {
    handler() {
      const { groupIndex } = this
      this.$emit('handler', { groupIndex })
    }
  }
}
</script>

<style lang="scss">
.textCircle{
  font-size: 12px;
  text-align: center;
  color: #2D9CDB;
  font-weight: bold;
  width: 45px;
  height: 18px;
}
.circle{
  width: 44px;
  height: 44px;
  border-radius: 50px !important;
  background: #2d9cdb;
  display: flex;
  justify-content: center;
  transform: rotate(90deg);
  .plus-icon {
    cursor: pointer;
  }
}

</style>
